$(() => {
    let total = $('.keyvisual img').length;
    let loaded = 0;

    let initCarousel = () => {
        if (loaded != total) return;
        $('.js-carousel').owlCarousel({
            loop: false,
            nav: true,
            dots: false,
            navClass: [
                'keyvisual-carousel__btn keyvisual-carousel__btn_prev',
                'keyvisual-carousel__btn keyvisual-carousel__btn_next'
            ],
            navText: [
                '<i class="fa fa-chevron-left"></i>',
                '<i class="fa fa-chevron-right"></i>'
            ],
            responsive: {
                0: {
                    items: 1,
                    autoHeight: true
                },

                1179: {
                    items: 1,
                    autoHeight: false
                }
            }
        })
    };

    $('.keyvisual img').each(function (i ,img) {
        let testImg = new Image();
        testImg.src = img.getAttribute('src');
        testImg.onload = function() {
            loaded++;
            initCarousel();
        }
        testImg.onerror = function() {
            $(img).parent().remove();
            loaded++;
            initCarousel();
        }
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/carousel.js